import PDP from '../sections/PDP';
import StoreInventorySearch from '../components/StoreInventory/StoreInventorySearch.js';
import GiftCardProduct from '../components/GiftCardProduct';
import Tooltip from '../components/Tooltip/index.js';
import ProductOptions from '../components/ProductOptions';
import ProductOverview from '../sections/ProductOverview';
import { ProductOverview as INFProductOverview } from '../sections/INF-ProductOverview';

document.addEventListener('DOMContentLoaded', () => {
  PDP();
  INFProductOverview();
  ProductOptions();
  ProductOverview();
  StoreInventorySearch();
  Tooltip();
  GiftCardProduct();
});
